import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as l } from "../../../../IconBase-CxZyIWw2.js";
const o = i((e, r) => /* @__PURE__ */ s.jsx(
  l,
  {
    ref: r,
    ...e,
    image: (a) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...a,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_4128",
              width: 32,
              height: 32,
              x: 8,
              y: 8,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M29.25 40c-.51 0-.97-.2-1.35-.58-1.57-1.6-1.56-6.26-1.42-13.73.12-6.51.26-13.89-1.61-15.8-.26-.27-.54-.39-.88-.39-2.36 0-2.39 7.93-2.41 14.3-.04 8.33-.07 16.2-4.1 16.2-.71 0-1.32-.26-1.84-.79-2.1-2.14-1.98-8.6-1.85-15.44.11-5.79.24-12.36-1.34-13.97-.2-.21-.41-.3-.68-.3-.97 0-2.27.57-2.27 5.47a.749.749 0 1 1-1.5 0C8 13.07 8 8 11.77 8c.67 0 1.26.25 1.75.75 2.02 2.05 1.9 8.37 1.77 15.06-.11 5.94-.24 12.67 1.42 14.36.23.23.47.34.77.34 2.53 0 2.56-8.16 2.59-14.71.03-8.48.06-15.8 3.91-15.8.75 0 1.41.28 1.95.84 2.32 2.36 2.18 9.41 2.04 16.88-.1 5.35-.22 11.42.99 12.65.12.12.2.13.28.13 2.41 0 2.65-7.83 2.83-14.12.27-8.42.51-16.38 4.72-16.38.8 0 1.47.27 1.99.81 1.38 1.43 1.26 4.41 1.17 6.8l-.01.21c-.02.42-.41.74-.78.72a.75.75 0 0 1-.72-.78l.01-.21c.08-2 .19-4.73-.75-5.7-.23-.24-.52-.35-.91-.35-2.76 0-3.01 8.27-3.21 14.92-.25 8.36-.46 15.58-4.33 15.58"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_4128)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M.506 1.553h46.182v46.182H.506z" }) })
        ]
      }
    )
  }
));
o.displayName = "AgencyWrinklesIcon";
export {
  o as AgencyWrinklesIcon,
  o as default
};
//# sourceMappingURL=index.js.map
